<template>
    <section>
        <div>
            <h1>Policy Guidance, Tools and Resources</h1>
        </div>
        <div>
            <p>
              This section provides Resident Coordinators, Resident Coordinator Offices and United Nations Country Teams with access to a curated collection of international standards, policy tools, methodologies, analytical products, guidance documents, good practices and other resources developed by United Nations entities to support integrated responses to corruption, organized crime and other challenges related to SDG 16 and the 2030 Agenda. Resources are organized by thematic areas and are intended to facilitate evidence-based analysis, policy dialogue, programme design and implementation at the country and regional levels. 
            </p>     
            <p>
                Each thematic area includes relevant international legal and normative frameworks, as well as mappings of United Nations programmes, initiatives and expertise, enabling users to identify available capacities, facilitate collaboration and connect with relevant partners across the United Nations system.
            </p>    
            <p>
                Resources are available in English and, subject to availability, in French, Portuguese and Spanish.
            </p>  
        </div>
        <v-row>
            <v-col v-for="card in cards" :key="card.id" cols="12" md="3">
                <router-link :to="{ name: card.component, params: { id: card.id } }" style="text-decoration: none;">
                    <v-card class="mx-auto" max-width="380" min-height="180">  <!-- Cara frontal del card con la imagen y el título -->
                        <div v-if="cardState[card.id] && !cardState[card.id].isFlipped">
                            <v-carousel :show-arrows="false" cycle height="180" hide-delimiters>
                                <v-carousel-item v-for="(image, index) in card.images" :key="index">
                                    <!-- Ajusta el estilo de v-img para cubrir el espacio del v-card -->
                                    <v-img class="align-end text-white" height="100%" :src="getImageSrc(image)" :style="{ 'object-fit': 'cover' }">
                                        <!-- Aplica el color blanco al título del v-card 
                                        <v-card-title style="color: white; font-size: 16px;" >{{ card.title }}</v-card-title>-->
                                    </v-img>
                                </v-carousel-item>
                            </v-carousel>
                        </div>
                        <div>
                            <v-card-title style="color: white; background-color: rgba(26,71,107,1); font-size: 13px; width: 100%; display: flex; justify-content: center; padding-top: 5px; padding-bottom: 5px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                {{ card.title }}
                            </v-card-title>
                        </div>
                    </v-card>
                </router-link>
            </v-col>
        </v-row>
    </section>
</template>

<script>
import NoticiaDetalle from './NoticiaDetalle.vue';
import Publication from './Publication.vue';
import axios from 'axios';

export default {
    components: {
        NoticiaDetalle,
        Publication,
    },
    data() {
        return {
            datos: [],
            dato: {
                oid: 0,
                title: '',
                subtitle: '',
                description: '',
                additionalInfo: '',
                images: '',
                r_images: '',
                link: '',
                folder: '',
            },
            cards: [
                {
                    id: 1,
                    title: 'Corruption',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 1',
                    images: ['1.png'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/0.%20UNODC%20Global?csf=1&web=1&e=8Sy2kH',
                    component: 'TCorruption'
                },
                {
                    id: 2,
                    title: 'Organized Crime',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['2.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'TOrganizedCrime'
                },
                {
                    id: 3,
                    title: 'Crime Prevention & Criminal Justice',
                    subtitle: 'INEGI',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 2Additional Info for Card 2Additional Info for CAdditional Info for Card 2Additional Info for Card 2Additional IAdditional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2nfo for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2ard 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2',
                    images: ['3.jpg'],                    
                    chip: ['7:00 AM', '9:00 AM', '11:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'TCrimePrevention'
                },
                {
                    id: 4,
                    title: 'Drugs',
                    subtitle: 'UNICEF',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 4',
                    images: ['4.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'TDrug'
                },
                {
                    id: 5,
                    title: 'Gender-Based Violence',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['5.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'TGender'
                },
                {
                    id: 6,
                    title: 'Prison Reform',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['6.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'TPrison'
                },
                {
                    id: 7,
                    title: 'Violence Against Children',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['7.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'TViolence'
                },
                {
                    id: 9,
                    title: 'Terrorism',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['9.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'TTerrorism'
                },
                {
                    id: 8,
                    title: 'Homicide',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['8.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'THomicides'
                },
                // {
                //     id: 10,
                //     title: 'Citizen Security (Coming Soon)',
                //     subtitle: 'Mexico',
                //     description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                //     additionalInfo: 'Additional Info for Card 7',
                //     images: ['10.jpg'],
                //     chip: ['7:00 AM', '9:00 AM'], 
                //     link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                // },
                /*
                {
                    id: 3,
                    title: 'Cybercrime',
                    subtitle: 'UNESCO',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 3',
                    images: ['Category3-1.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/UNESCO%20rule%20of%20law%20through%20education?csf=1&web=1&e=3Dt35A',
                    component: ''
                },
                {
                    id: 5,
                    title: 'Environmental crimes',
                    subtitle: 'Bolivia',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 5',
                    images: ['Category5-1.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },
                {
                    id: 6,
                    title: 'Firearms',
                    subtitle: 'Brazil',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 6',
                    images: ['Category6-1.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },                
                {
                    id: 8,
                    title: 'Human trafficking and migrant smuggling',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['Category8-1.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },
                {
                    id: 9,
                    title: 'Money laundering',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['Category9-1.jpg'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },*/
            ],
            cardState: {},
        };  
    },/*
    mounted() {
      this.listar();
    },*/
    methods: {
        // Obtener la lista de Categiries
        /*async listar() {
            try {
                const response = await axios.get('api/Categories/Listar');
                this.datos = response.data;

                // Ahora que tienes los datos, puedes mapearlos al formato que esperas para las tarjetas (cards)
                this.cards = this.datos.map(category => {
                    return {
                        id: category.oid,
                        title: category.title,
                        subtitle: category.subtitle,
                        description: category.description,
                        additionalInfo: category.additionalInfo,
                        images: ['fondo2.jpg'],   // Asegúrate de manejar el caso donde images es null o undefined
                        link: category.link,
                    };
                });
            } catch (error) {
                console.error(error);
            }
        },*/
        getImageSrc(filename) {
            return require(`../assets/${filename}`);
        },
        flipCard(cardId, isFlipped) {
            // Verificar si cardState[cardId] existe antes de acceder a sus propiedades
            if (this.cardState[cardId]) {
                this.$set(this.cardState[cardId], 'isFlipped', isFlipped);
            } else {
                // Si no existe, inicialízalo con isFlipped
                this.$set(this.cardState, cardId, { isFlipped });
            }
        },
    },
    created() {
        // Initialize cardState for each card
        this.cards.forEach(card => {
            this.$set(this.cardState, card.id, { isFlipped: false });
        });
    },
    
};
</script>

<style>
    .v-card {
        perspective: 1000px;
        transition: transform 0.5s;
    }

    .v-card.is-flipped {
        transform: rotateY(180deg);
    }

    .custom-h1 {
        font-size: 2.5em; /* Puedes ajustar el tamaño según tus necesidades */
        font-weight: bold; /* Otras propiedades de estilo si es necesario */
    }

    .custom-h3 {
        font-size: 1.5em; /* Puedes ajustar el tamaño según tus necesidades */  
    }
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 17px;        
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
    }
    h2 {
        font-family: 'Heebo', sans-serif;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
</style>